import React, { Component } from 'react'
import TopCards from './TopCards'; 
import {Pie} from 'react-chartjs-2';
import {getData2} from '../Api/Config';



class Dashboard extends Component {
  
  state={
    completedApp: 0,
    iceBoxApp: 0,
    inProgressApp: 0,
    inReviewApp: 0,
    liveApp: 0,
    todoApp: 0,
    totalApp: 0
  }
  
  componentDidMount=()=>{
    getData2("https://api.nirmallabs.com/api/admin/v1/summary").then(res=>{
      if(res){
        this.setState({
          completedApp: res.completedApp,
          iceBoxApp: res.iceBoxApp,
          inProgressApp: res.inProgressApp,
          inReviewApp: res.inReviewApp,
          liveApp: res.liveApp,
          todoApp: res.todoApp,
          totalApp: res.totalApp
        });
      }
    }).catch(err=>{
      console.log(err);
    })
  }

    render(){
      let {iceBoxApp,todoApp,inProgressApp,inReviewApp,completedApp,liveApp} = this.state;
      const data = {
        labels: [
          'ICE Box',
          'To Do',
          'In Progress',
          'In Review',
          'Completed',
          'Live',
        ],
        datasets: [{
          data: [iceBoxApp, todoApp, inProgressApp,inReviewApp, completedApp, liveApp],
          backgroundColor: [
            '#90caf9',
          '#3949ab',
          '#eeff41',
          '#FF6384',
          '#36A2EB',
          '#FFCE56'
          ],
          hoverBackgroundColor: [
            '#90caf9',
            '#3949ab',
            '#eeff41',
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
          ]
        }]
      };
        return (
            <div>
                <TopCards data={this.state} />
                <div className="col l8 m12 card hoverable">
                  <div className="card-content">
                    <span>Apps</span>
                   <Pie data={data} />
                  </div>
                  </div>
            </div>
        )
    }
}

export default Dashboard
